var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 198.3 39.7",
    style: {
      enableBackground: "new 0 0 198.3 39.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{enable-background:new    ;}\r\n\t.st1{fill:#183153;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.1,11.1c5,0,8.2,3.1,8.2,9.5s-3.2,9.5-8.2,9.5h-4c-5.1,0-8.2-3.1-8.2-9.5s3.2-9.5,8.2-9.5H14.1z M10.4,14.8 c-3.3,0-4.8,1.7-4.8,5.8s1.4,5.8,4.8,5.8h3.3c3.3,0,4.8-1.7,4.8-5.8s-1.5-5.8-4.8-5.8H10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40,11.1c5,0,8.2,3.1,8.2,9.5S45,30.1,40,30.1h-8.4v7.6h-3.8V19.3c0-5.5,2.4-8.1,7-8.1H40z M31.5,26.4h8 c3.3,0,4.8-1.7,4.8-5.8s-1.4-5.8-4.8-5.8h-3.7c-3.1,0-4.3,1.4-4.3,4.6V26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.3,11.1V6.6h3.9v4.5h5.3v3.7h-5.3v9c0,2.1,0.8,2.8,2.6,2.8h2.6v3.5h-3.4c-3.9,0-5.6-1.6-5.6-6.6v-8.8h-2.6 v-3.7H54.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71.9,4v4.4H68V4H71.9z M71.9,11.1v19H68v-19H71.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.1,11.1v3.7H83.6c-1.8,0-2.5,0.7-2.5,2.2c0,1.3,0.6,2.1,2.7,2.1h4.5c5.3,0,6.6,2.4,6.6,5.4 c0,3.4-1.8,5.8-6.2,5.8H77.5v-3.7h11.1c1.8,0,2.5-0.6,2.5-2.1c0-1.5-0.8-2.1-2.7-2.1h-4.5c-5.3,0-6.6-2.6-6.6-5.5 c0-3.4,1.8-5.5,6.2-5.5H94.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112.6,11.1c4.5,0,6.4,2.2,6.4,5.8c0,3.5-1.8,5.5-6.4,5.5h-9v1.4c0,1.5,0.8,2.6,2.9,2.6h11.6v3.7h-11.6 c-4.8,0-6.6-2.7-6.6-6.3v-6.5c0-3.6,1.9-6.3,6.6-6.3H112.6z M103.5,19.5h8.9c2.1,0,2.8-0.9,2.8-2.3c0-1.4-0.8-2.4-2.7-2.4h-6.1 c-2.1,0-2.9,1.2-2.9,2.6V19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.4,11.1l1.7,14.8c0.1,0.8,0.5,1.2,1.4,1.2c0.9,0,1.2-0.4,1.4-1l2.7-11.5c0.6-2.5,2.2-3.9,5.2-3.9 c3,0,4.5,1.3,5.1,3.9l2.6,11.5c0.1,0.7,0.6,1,1.4,1c0.9,0,1.2-0.4,1.3-1.2l2-14.8h4.1l-2.1,15c-0.4,2.6-1.9,4.4-5.3,4.4 c-3,0-4.5-1.3-5.1-3.9l-2.6-11.6c-0.1-0.6-0.7-0.9-1.4-0.9c-0.8,0-1.3,0.3-1.4,0.9l-2.7,11.6c-0.6,2.6-2.2,3.9-5.3,3.9 c-3.5,0-4.8-1.8-5.1-4.4l-2-15H126.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M172.4,11.1c4.5,0,6.4,2.2,6.4,5.8c0,3.5-1.8,5.5-6.4,5.5h-9v1.4c0,1.5,0.8,2.6,2.9,2.6h11.6v3.7h-11.6 c-4.8,0-6.6-2.7-6.6-6.3v-6.5c0-3.6,1.9-6.3,6.6-6.3H172.4z M163.3,19.5h8.9c2.1,0,2.8-0.9,2.8-2.3c0-1.4-0.8-2.4-2.7-2.4h-6.1 c-2.1,0-2.9,1.2-2.9,2.6V19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M197.3,11.1v3.7h-6.7c-1.7,0-2.4,0.8-2.4,2.4v12.9h-3.8V16.7c0-3.8,1.4-5.5,5.1-5.5H197.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo_dark.d32aa626c1b05a1458cf21b02ea91a7e.svg";
export { ForwardRef as ReactComponent };